import LocalStorageConstant from "./localStorage.constant";

const getLocalRefreshToken = () => {
    return localStorage.getItem(LocalStorageConstant.refreshToken);
};

const getLocalAccessToken = () => {
    return localStorage.getItem(LocalStorageConstant.accessToken);
};

const addOrUpdateLocalAccessToken = (token: string) => {
    localStorage.setItem(LocalStorageConstant.accessToken, token);
};

const addOrUpdateLocalRefreshToken = (token: string) => {
    localStorage.setItem(LocalStorageConstant.refreshToken, token);
};

const removeUser = () => {
    localStorage.removeItem(LocalStorageConstant.user);
    localStorage.removeItem(LocalStorageConstant.accessToken);
    localStorage.removeItem(LocalStorageConstant.refreshToken);
};

const clearAllTokens = () => {
    localStorage.removeItem(LocalStorageConstant.accessToken);
    localStorage.removeItem(LocalStorageConstant.refreshToken);
    localStorage.removeItem("loginemail");
    localStorage.removeItem("userId");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userTimeZone");
    localStorage.removeItem("userUOM");
    localStorage.removeItem("pinnedAssetsMapByCustomer");
};

const TokenService = {
    removeUser,
    getLocalAccessToken,
    getLocalRefreshToken,
    addOrUpdateLocalAccessToken,
    addOrUpdateLocalRefreshToken,
    clearAllTokens,
};

export default TokenService;
